import React from 'react';
import { Button } from '@mui/material';


/**
 * A React component that renders a button with a specific design.
 * 
 * @param {Object} props - The component props.
 * @param {string} [props.text='ADHA - 9 slots'] - The text to display on the button.
 * @param {string} [props.variant='outlined'] - The button variant.
 * @param {string} [props.color='primary'] - The button color.
 * @param {Function} props.onClick - The callback function to call when the button is clicked.
 */
const BntAdha9Slots = ({
  text = 'ADHA – 9 slots',
  variant = 'outlined',
  color = 'primary',
  onClick
}) => {
  return (
    <Button
      size="large"
      variant={variant}
      color={color}
      onClick={onClick}
      sx={{
        width: '250px',
        height: '40px',
        fontSize: '16px',
        padding: '8px 10px',
        textTransform: 'none'
      }}
    >
      {text}
    </Button>
  );
};

/**
 * Exports the BntAdha9Slots component as the default export.
 */
export default BntAdha9Slots;